import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap"

export default class Visualizer extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    // const sticky = new Sticky({
    //   el: qs(".sticky", this.el),
    //   sticky: qs(".sticky-content", this.el),
    //   isSmooth: store.flags.isSmooth,
    // })

    // sticky.resize()
  }

  animate() {
    const wrapper = qs(".wrapper", this.el)
    const title = qsa(".title .char-1", this.el)
    const paragraph1 = qsa(".description-1 .line-0", this.el)
    const paragraph2 = qsa(".description-2 .line-0", this.el)

    const images = qsa(".img-wrapper", this.el)

    images.forEach(img => {
      gsap.from(qs("img", img), {
        y: "100%",
        duration: 1.2,
        scrollTrigger: {
          trigger: img,
          start: "top bottom",
        },
      })
    })

    gsap.from(title, {
      y: "50",
      autoAlpha: 0,
      duration: 1.2,
      stagger: 0.01,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(paragraph1, {
      y: "50",
      autoAlpha: 0,
      duration: 1.2,
      stagger: 0.07,
      scrollTrigger: {
        trigger: paragraph1,
        start: "top bottom",
      },
    })

    const description1 = qs(".description-1", this.el)
    const description2 = qs(".description-2", this.el)

    // if (store.flags.isSmooth) {
    //   ScrollTrigger.create({
    //     pin: true,
    //     trigger: description1,
    //     start: "top-=40px top",
    //     end: `${bounds(wrapper).height - bounds(description1).height - 40}px`,
    //   })
    //   ScrollTrigger.create({
    //     pin: true,
    //     trigger: description2,
    //     start: "top-=40px top",
    //     end: `${bounds(wrapper).height - bounds(description2).height - 40}px`,
    //   })
    // }

    gsap.from(paragraph2, {
      y: "50",
      autoAlpha: 0,
      duration: 1.2,
      stagger: 0.07,
      scrollTrigger: {
        trigger: paragraph2,
        start: "top bottom",
      },
    })

    // gsap.from(images, {
    //   y: "100%",
    //   duration: 1.2,
    //   stagger: 0.07,
    //   scrollTrigger: {
    //     trigger: images,
    //     start: "top bottom",
    //   },
    // })
  }
}
